import classNames from "classnames";
import DocumentIcon from "src/components/documenticon/DocumentIcon";
import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import CmsImage from "src/components/images/CmsImage";
import IFilmnytt from "src/lib/types/Filmnytt";
import { ThemeValues } from "src/lib/types/IForsidenV2";
import { getImage, getUrlForDoctype } from "src/lib/types/sanity";
import styles from "./SquareImageLeftTitle.module.css";

//#region [Props]
type SquareImageLeftTitleProps = {
    document: IFilmnytt;
    isStreamingContext?: boolean;
    themeValue?: ThemeValues;
    showSeparator?: boolean;
    className?: string;
    imageWidth?: number;
    useSectionTitle?: boolean;
};
//#endregion

//#region [Component]
export default function SquareImageLeftTitle({ document, isStreamingContext, themeValue, showSeparator, className, imageWidth = 128, useSectionTitle }: SquareImageLeftTitleProps) {
    const slug: string = document.slug?.current;
    const url = getUrlForDoctype(document._type, slug, document.isStreaming as boolean | undefined ?? isStreamingContext, document);
    const image = getImage(document);
    const title = useSectionTitle ? (document.sectionPageTitle as string ?? document.title) : document.title;

    return <article className={classNames(className,
        styles.SArticle,
        {
            "withSeparator": showSeparator // withSeparator must be :global
        },
        themeValue ?? "dark")}>
        <FilmwebLink to={url!}
            className={classNames(styles.SFilmwebLink,
                {
                    [styles.contentAd]: document.isAdContent,
                    "contentAd": document.isAdContent
                },
                themeValue ?? "dark")}>
            {image && <div className={classNames(styles.SImgContainer,
                {
                    [styles.contentAd]: document.isAdContent,
                    "contentAd": document.isAdContent
                },
                themeValue ?? "dark")} style={{ width: imageWidth + "px" }}>
                <CmsImage className={styles.SCmsImage} image={image} alt={image.asset?.altText ?? ""} width={imageWidth} crop applyAspectRatio nonPosterAspect={1} />
                <DocumentIcon className={styles.SDocumentIcon} document={document} />
            </div>}
            <div className={classNames(styles.STitleContainer,
                {
                    [styles.contentAd]: document.isAdContent,
                    "contentAd": document.isAdContent
                }
            )}>
                <h1 className={styles.STitle}>{title}</h1>
            </div>

        </FilmwebLink>
    </article>;
}
//#endregion
